import React, { Fragment } from 'react'
import {AppProjectTree,AppTableSearch,SearchEnum,AppSearchItem,AppSearchInput}from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon } from 'antd';
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'

const options = [
    {label:'111',value:'222'},
    {label:'111',value:'33'},
    {label:'111',value:'44'},
    {label:'111',value:'55'},
    {label:'111',value:'66'},
    {label:'111',value:'77'},
    {label:'111',value:'88'},
    {label:'111',value:'99'},
    {label:'111',value:'00'},
    {label:'111',value:'09'},
    {label:'111',value:'77'},
    {label:'111',value:'uu'},
    {label:'111',value:'ii'},
    {label:'111',value:'oo'},
    {label:'111',value:'pp'},
    {label:'111',value:'222'},
    {label:'111',value:'kk'},
    {label:'111',value:'kk'},
    {label:'111',value:'gg'},
    {label:'111',value:'hh'},
    {label:'111',value:'hyy'},
    {label:'111',value:'ff'},
    {label:'111',value:'vv'},
    {label:'111',value:'bb'},
    {label:'111',value:'nn'},
    {label:'111',value:'mm'},
    {label:'111',value:'ll'},
    {label:'111',value:'aa'},
    {label:'111',value:'dd'},
    {label:'111',value:'ee'},
]

export const AppTableSearchDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、配置查询区域。<br/>
                2、分为普通查询和高级查询区域<br/>
                3、查询条件可以支持两种模式解析，一种为对象，后台需要自代码解析，一种为List平台提供解析方法<br/>
                4、每个查询项必须设置keyName<br/>
                5、开放提供者，可以自己设置布局或则增加扩展的查询项<br/>
                6、引用：import {`{AppTableSearch}`} from 'qcc'<br/>
                7、demo位置：src/demo/components/AppTableSearchDemo.tsx<br/>
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row  className="demo-title">
                    <label>项目查询：</label>
                    <Row style={{fontSize:12}}>
                    1）关键API为场景（scene）与后台的数据源保持一致<br/>
                    2）默认的解析条件为=，如果设置为其他，则后台需要相应的对条件进行解析，根据场景实现。
                    </Row>
                    <Row style={{padding:20,paddingTop:0}}>
                        <div style={{width:300}}>
                            <AppProjectTree scene={10000}/>
                        </div>
                    </Row>
                </Row>
              

                <Row  className="demo-title">
                    <label>普通查询：</label>
                    <Row style={{fontSize:12}}>
                    1）可以设置多个字段（field）<br/>
                    2）解析条件仅支持like<br/>
                    </Row>
                    <Row style={{padding:20,paddingTop:0}}>
                        <div style={{width:300}}>
                            <AppSearchInput />
                        </div>
                    </Row>
                </Row>

                <Row  className="demo-title">
                    <label>高级查询：</label>
                    <Row style={{fontSize:12}}>
                    1）如果要扩展类型，使用AppSearch的provider提供者。<br/>
                    </Row>
                    <Row style={{padding:20,paddingTop:0}}>
                        <AppTableSearch>
                            <AppTableSearch.Common>
                                <AppSearchItem.ProjectTree keyName='organId' field='a.organid' lable='项目'/>
                                <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='a.b|a.c'/>
                            </AppTableSearch.Common>
                            <AppTableSearch.Advanced>
                                <AppSearchItem.Advanced keyName='text' field='text' lable='文本:'/>
                                <AppSearchItem.Advanced keyName='multCheck' field='multCheck' itemType={SearchEnum.itemType.multCheck} options={options} lable='多选:'/>
                                <AppSearchItem.Advanced keyName='numberRange' field='numberRange' itemType={SearchEnum.itemType.numberRange} lable='数字区间:'/>
                                <AppSearchItem.Advanced keyName='dateRange' field='dateRange' itemType={SearchEnum.itemType.dateRange} lable='日期区间:'/>
                            </AppTableSearch.Advanced>
                        </AppTableSearch>
                    </Row>
                </Row>

            </div>
            
            <h1>API</h1>
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppTableSearchDemo.tsx